import bannerImg from "../../../../../assets/image_banner_programa_beneficios.png";

import { BenefitsBannerContent } from "../types/BenefitsBanner.types";

/**
 * Imagem da campanha (arte 3:1 produzida pelo marketing). A arte já contém
 * título, descrição e chamada — o banner é apenas a imagem clicável.
 */
export const benefitsBannerImage = bannerImg;

/** Conteúdo (não-visual) da campanha: texto acessível e destino do CTA. */
export const benefitsBannerContent: BenefitsBannerContent = {
  /** Usado como `alt` da imagem (a copy visível vive na própria arte). */
  altText: "Revendedor bandeirado Atem tem benefícios extras!",
  /** Destino do clique (site institucional de marketing, abre em nova aba). */
  ctaHref: "https://marketing.atem.com.br/revendedores/",
};
